import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLoading from '../../../common/componentsV2/elements/PageLoading';
import {
  RcQuotesStyles,
} from './BackOfficeVehicleQuotes.styles';
import {
  addBackOfficeQuoteToCart,
  loadBackOfficeQuotes,
  removeBackOfficeQuoteFromCart,
  resetBackOfficeQuotes,
} from '../../../features/backofficeResults/backofficeResultsActions';
import { Layout } from '../components/Layout/Layout';
import { AvvisoAlert } from '../../RcQuotes.styles';
import { confirmAlert } from '../../../common/utils/alerts';
import {
  RiskContainer,
} from '../../../common/components/redesignComponents/Cards/ProfessionInfoCard.styles';
import HouseModalButtons from '../../HouseProduct/components/HouseModalButtons';
import HouseModal from '../../HouseProduct/components/HouseModal';
import { getQuoteTypes } from '../../../features/utilities/utilitiesActions';
import { V2FontImport } from '../../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import HomeSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/HomeSummaryCard';
import QuoteCostSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import FailedQuotationsComponent from '../../../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

function BackOfficeHomeQuotes() {
  // const navigate = useNavigate();
  const { requestToken } = useParams();
  const state = useSelector((store) => store.backofficeResults.back_office_quotes);
  const {
    loading,
    requestInfo,
    quotes,
    failedQuotes,
    processingQuote,
    addingQuote,
    customer,
    risk_quotations,
  } = state;

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);
  // const modifyData = () => {
  //   navigate(`/backoffice/quote/${requestToken}/tutela-legale`);
  // };
  // const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    loadBackOfficeQuotes(requestToken);
    getQuoteTypes();

    return () => {
      resetBackOfficeQuotes();
    };
  }, []);

  // const refresh = () => loadBackOfficeQuotes(requestToken);

  if (loading) {
    return <PageLoading />;
  }

  const fetchQuotes = () => {
    loadBackOfficeQuotes(requestToken);
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addBackOfficeQuoteToCart(quoteId, fetchQuotes));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeBackOfficeQuoteFromCart(quoteId, fetchQuotes));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (risk_quotations && risk_quotations[type.id] !== undefined) {
        for (let i = 0; i < risk_quotations[type.id].length; i++) {
          const item = risk_quotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  return (
    <Layout>
      <V2FontImport />
      <RcQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <HomeSummaryCard
              customer={customer}
              insuranceRequest={requestInfo}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={risk_quotations}
              getTotal={getTotal}
              rcTypeLabel={processingQuote?.product_name}
            />
          </ResultOverviewRow>
          {/* <div className="row">
            <div className="col-12 ">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end ">
                  <div>
                    {localStorage.getItem('quoteNewResult') === 'done' && (
                    <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                      <button className="btn btn-success px-2 py-1">Tutorial</button>
                    </div>
                    )}
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div> */}

          {quotes && !quotes.res_civile
            && (
              <AvvisoAlert role="alert">
                <h4>Avviso!</h4>
                <p>Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </AvvisoAlert>
            )}

          {quotes && quotes.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => {
                    const currTypes = processingQuote !== null ? requestInfo.quotations?.filter((q) => q.company_id === processingQuote.company_id)?.map((el) => el.quote_type) : [];

                    if (processingQuote === null) {
                      return (
                        <React.Fragment key={index}>
                          {quotes && quotes[type.id] && (
                            <HouseModalButtons
                              insuranceRequest={requestInfo}
                              processingQuote={processingQuote}
                              type={type}
                              removeItemFromCart={removeItemFromCart}
                              riskQuotations={risk_quotations}
                              quotations={quotes}
                            />
                          )}
                        </React.Fragment>
                      );
                    }

                    if (currTypes.includes(type.id) || type.id === 'res_civile') {
                      return (
                        <React.Fragment key={index}>
                          {quotes && quotes[type.id] && (
                            <HouseModalButtons
                              insuranceRequest={requestInfo}
                              processingQuote={processingQuote}
                              type={type}
                              removeItemFromCart={removeItemFromCart}
                              riskQuotations={risk_quotations}
                              quotations={quotes}
                            />
                          )}
                        </React.Fragment>
                      );
                    }

                    // return (
                    //   <React.Fragment key={index}>
                    //     {quotations && quotations[type.id] && (
                    //     <HouseModalButtons
                    //       insuranceRequest={insuranceRequest}
                    //       processingQuote={processingQuote}
                    //       type={type}
                    //       removeItemFromCart={removeItemFromCart}
                    //       riskQuotations={riskQuotations}
                    //     />
                    //     )}
                    //   </React.Fragment>
                    // );

                    return null;
                  })}
                </RiskContainer>

                {quoteTypes.map((type, index) => (
                  <HouseModal
                    insuranceRequest={requestInfo}
                    type={type}
                    key={index}
                    addingQuote={addingQuote}
                    processingQuote={processingQuote}
                    quotations={quotes}
                    selectQuotation={selectQuotation}
                  />
                ))}
              </>
            )}
        </div>

        {failedQuotes !== null && failedQuotes.length > 0 && (
          <FailedQuotationsComponent failedQuotes={failedQuotes} />
        )}
      </RcQuotesStyles>
    </Layout>
  );
}

export default BackOfficeHomeQuotes;
